import * as Yup from "yup";
import checkout from "./form";

const {
  formField: {
    certificate,
    fullName,
    firstTime,
    signer,
    supplementaryForThe,
    taxCalculationPeriod,
    taxId,
    taxpayerName,
    timeSign,

    checkbox1,
    checkbox2,
    field01a,
    field01b,
    field01c,
    field01d,
    checkbox3,
    checkbox4,
    checkbox5,
    checkbox6,
  },
} = checkout;

const validation = Yup.object().shape({
  [checkbox1.name]: Yup.string().optional(),
  [checkbox2.name]: Yup.string().optional(),
  [checkbox3.name]: Yup.string().optional(),
  [checkbox4.name]: Yup.string().optional(),
  [checkbox5.name]: Yup.string().optional(),
  [checkbox6.name]: Yup.string().optional(),
  [field01a.name]: Yup.number().required(field01a.errorMsg),
  [certificate.name]: Yup.string().required(certificate.errorMsg),
  [fullName.name]: Yup.string().required(fullName.errorMsg),
  [firstTime.name]: Yup.string().required(firstTime.errorMsg),
  [signer.name]: Yup.string().required(signer.errorMsg),
  [supplementaryForThe.name]: Yup.string()
    .matches(/^\d+$/, supplementaryForThe.invalidMsg)
    .required(supplementaryForThe.errorMsg),
  [taxCalculationPeriod.name]: Yup.number().required(taxCalculationPeriod.errorMsg),
  [taxId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxId.invalidMsg)
    .required(taxId.errorMsg),
  [taxpayerName.name]: Yup.string().required(taxpayerName.errorMsg),
  [timeSign.name]: Yup.number().required(timeSign.errorMsg),
  [field01b.name]: Yup.number().required(field01b.errorMsg),
  [field01c.name]: Yup.number().required(field01c.errorMsg),
  [field01d.name]: Yup.number().required(field01d.errorMsg),
});

export default validation;
